/**
 * @fileoverview
 * Estende os locales do openblock-l10n para incluir português brasileiro (pt-br)
 * e outras traduções que podem não estar ativas no pacote original
 */

import locales from 'openblock-l10n';
import {localeData, isRtl} from 'openblock-l10n';
import editorMessages from 'openblock-l10n/locales/editor-msgs';
import additionalEditorTranslations from './editor-translations-pt-br.json';
import additionalEditorTranslationsEn from './editor-translations-en.json';

// Estende os locales para incluir pt-br
const extendedLocales = {
    ...locales,
    'pt-br': {
        name: 'Português Brasileiro'
    }
};

// Estende as mensagens do editor para incluir pt-br
// Primeiro, verifica se já existe pt-br nas mensagens
const extendedEditorMessages = {
    ...editorMessages
};

// Se pt-br não estiver nas mensagens do editor, adiciona usando en como fallback
if (!extendedEditorMessages['pt-br']) {
    extendedEditorMessages['pt-br'] = extendedEditorMessages['en'] || {};
}

// Mescla as traduções adicionais do editor (loader, menu-bar, etc.) com as traduções existentes
// Isso garante que as traduções em pt-br sejam aplicadas mesmo se não estiverem no openblock-l10n
extendedEditorMessages['pt-br'] = {
    ...extendedEditorMessages['pt-br'],
    ...additionalEditorTranslations
};

// Sobrescreve também mensagens específicas em inglês (en), quando quisermos trocar textos do OpenBlock
// para o LabCode sem depender do pacote openblock-l10n.
extendedEditorMessages['en'] = {
    ...(extendedEditorMessages['en'] || {}),
    ...additionalEditorTranslationsEn
};

// Nota: As mensagens de blocos são carregadas dinamicamente pelo ScratchBlocks
// quando setLocale é chamado. O arquivo pt-br.json já existe em 
// openblock-l10n/editor/blocks/pt-br.json e será carregado automaticamente.

export {
    extendedLocales as locales,
    localeData,
    isRtl,
    extendedEditorMessages as editorMessages
};

